import React from 'react';
import Skeleton from 'react-loading-skeleton';

import FormattedPrice from 'src/shared/components/common/price/FormattedPrice';

import { DiscountsInfoToolTip } from './DiscountsToolTip';

export type ItemPriceProps = {
  loading: boolean;
  title: string | React.ReactNode;
  amount?: number | null;
  negative?: boolean;
  amountPrefix?: string;
  enableTooltip?: boolean;
  shippingMessage?: string;
};

const ItemPrice = ({
  loading,
  title,
  amount,
  negative,
  amountPrefix = '',
  enableTooltip = true,
  shippingMessage
}: ItemPriceProps) => {
  if(amount === undefined || amount === null) {
    return null;
  }
  // make negative if not already and let the formatter properly format negative currency
  const normalizedAmount = negative && amount > 0 ? amount * -1 : amount;

  const isDiscounts = title === 'Discounts';
  return (
    <div data-testid={`${title}-item-test-id`} className={`cart-flex-row ${loading ? 'loading' : ''}`}>
      {loading ?
        <Skeleton width="100%" height="100%" /> :
        <>
          <div className="titleAndTooltip">
            <span data-testid={'item-price-title'}>{title}</span>
            {/* We do not want to show the tooltip or certain pages (i.e. the confirmation page) */}
            {isDiscounts && enableTooltip && <DiscountsInfoToolTip />}
          </div>
          {shippingMessage ?
            <span data-testid={'item-price-amount'}>{shippingMessage}</span> :
            <span data-testid={'item-price-amount'}>{amountPrefix}{<FormattedPrice value={normalizedAmount} />}</span>}
        </>}
    </div>
  );
};

export default ItemPrice;
